import {
  Alert,
  Box,
  Typography,
  useTheme,
  List,
  ListItem,
  ListItemText,
  FormHelperText,
} from '@mui/material';
import {
  objectToCSVByKey,
  useLocalization,
  useUserAccess,
} from '@ui-framework/index';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';

function ProfileCompleteness({ status, serviceProviderId, store }) {
  const { dynamicMessage } = useLocalization();
  const navigate = useNavigate();
  const theme = useTheme();
  const userAccess = useUserAccess();
  const warnings = [];

  const isSA = userAccess.isSA();
  const isAdmin = userAccess.isAdmin();

  if (status?.hasSkills === false) {
    warnings.push({
      label: dynamicMessage(
        'Skills: At least one Industry must be configured to receive any jobs.',
      ),
      onClick: () => {
        navigate(`/serviceproviders/edit/${serviceProviderId}/4`);
      },
    });
  }
  if (status?.hasNotificationEmail === false) {
    warnings.push({
      label: dynamicMessage(
        'Setup:  Dispatch Notifications Email address must be set.',
      ),
      onClick: () => {
        navigate(`/serviceproviders/edit/${serviceProviderId}/5`);
      },
    });
  }
  if (status?.hasInsightCallDefault === false) {
    warnings.push({
      label: dynamicMessage(
        'Setup: Customer Communication default phone number needs to be set for Voice.',
      ),
      onClick: () => {
        navigate(`/serviceproviders/edit/${serviceProviderId}/5`);
      },
    });
  }
  if (status?.hasInsightSmsDefault === false) {
    warnings.push({
      label: dynamicMessage(
        'Setup: Customer Communication default phone number needs to be set for SMS Opt-in.',
      ),
      onClick: () => {
        navigate(`/serviceproviders/edit/${serviceProviderId}/5`);
      },
    });
  }
  if (status?.hasDispatchMethod === false) {
    warnings.push({
      label: dynamicMessage(
        `System Settings (Dispatch): Dispatch method should to be set.${isSA ? '' : ' Contact your Service Administrator to update.'}`,
      ),
      ...((isSA || isAdmin) && {
        onClick: () => {
          navigate(`/serviceproviders/edit/${serviceProviderId}/6/1`);
        },
      }),
    });
  }

  if (status?.hasServiceTravelDistance === false) {
    warnings.push({
      label: dynamicMessage(
        'Company Info: Default Service Travel Distance should to be set.',
      ),
      onClick: () => {
        navigate(`/serviceproviders/edit/${serviceProviderId}/1`);
      },
    });
  }

  if (status?.hasRateCard === false) {
    warnings.push({
      label: dynamicMessage(
        `System Settings (Claims): Rate card should be set.${isSA ? '' : '  Contact your Service Administrator to update.'}`,
      ),
      ...(isSA ||
        (isAdmin && {
          onClick: () => {
            navigate(`/serviceproviders/edit/${serviceProviderId}/6`);
          },
        })),
    });
  }

  if (
    Array.isArray(status?.hasInvalidLocationAddress) &&
    status?.hasInvalidLocationAddress?.length > 0
  ) {
    warnings.push({
      label: dynamicMessage(
        `Locations: ${status?.hasInvalidLocationAddress?.length} location${
          status?.hasInvalidLocationAddress?.length > 1 ? 's' : ''
        } require${
          status?.hasInvalidLocationAddress?.length === 1 ? 's' : ''
        } review for receiving jobs`,
      ),
      onClick: () => {
        const locationNumberString = objectToCSVByKey(
          status?.hasInvalidLocationAddress,
          'locationNumber',
        );
        const filters = [
          {
            field: 'locationNumber',
            operator: 'in',
            value: locationNumberString,
          },
        ];
        // ServiceProviderLocationList is store name from locations list page
        store.domain.list.set('ServiceProviderLocationList', { filters });
        navigate(`/serviceproviders/edit/${serviceProviderId}/3/list`);
      },
    });
  }

  if (warnings?.length === 0) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{
        mb: 1,
        border: '1px solid',
        borderColor: theme.palette.warning.light,
        pb: 0,
      }}>
      <Box textAlign="left">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
            {dynamicMessage('Profile Status')}
          </Typography>
        </Box>
        <List sx={{ listStyleType: 'disc', pl: 2, pt: 0.1 }}>
          {warnings?.map(item => {
            return (
              <ListItem
                key={item?.label}
                sx={{
                  display: 'list-item',
                  pl: 0,
                  m: 0,
                  py: 0,
                  '&:hover .MuiListItemText-root': {
                    ...(item.onClick && { textDecoration: 'underline' }),
                    cursor: 'pointer',
                  },
                }}>
                <ListItemText
                  {...(item.onClick ? { onClick: item.onClick } : {})}
                  sx={{ fontSize: '0.9em' }}>
                  {item?.label}
                </ListItemText>
              </ListItem>
            );
          })}
        </List>
      </Box>
      <Box>
        <FormHelperText>
          *Click any error to navigate to the section and make corrections.
        </FormHelperText>
      </Box>
    </Alert>
  );
}

export default observer(ProfileCompleteness);
